import useEditingStore from '@hooks/useEditingStore';
import useLangString from '@hooks/useLangString';
import { $tourData } from '@stores/dataStores';
import { $editingFlag } from '@stores/editingStores';
import { WFirstSceneButton } from '../WFirstSceneButton';
import WLogo from '../WLogo';
import { WSandTableButton } from '../WSandTableButton';
import useNickname from '../useNickname';

function WUserInfoMA() {
  const { name } = useNickname();
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });

  const lang = useLangString(
    {
      author: ['创作者：', 'Author: '],
      pv: ['～人来过', '～ views'],
    },
    []
  );

  const showName = !!(flag?.showAuthorName ?? 1);
  const showPv = !!(flag?.showTourPV ?? 1);

  return (
    <div className="absolute top-20 left-20">
      {(showName || showPv) && (
        <div className="mb-15 flex items-center">
          {showName && <div className="mr-20">{`${lang.author}${name}`}</div>}
          {showPv && <div>{lang.pv}</div>}
        </div>
      )}
      <WLogo />
      <WSandTableButton />
      <WFirstSceneButton />
    </div>
  );
}

export default WUserInfoMA;
